import {AppState} from '../reducer';

export const sidebarSelector = (state: AppState): boolean => state.sidebarReducer.isCollapsed;
